// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CheckOutAction from './data'

export default function CheckOutActionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CheckOutAction">
      <CheckOutAction {...props}>
        {children}
      </CheckOutAction>
    </Flow>
  )
}
